import React from 'react'
import Settings from '../../Settings'
import {StartPage, PlayButton} from './Components'

import startButton from './../../theme/img/start-button.png'

export const Start = () => {
  const hasIntro = Settings.intro.show === true
  const hasMultipleCategories = Settings.categories.length !== 1
  const category = hasMultipleCategories ? null : Settings.categories[0]

  const chosenLocale = Settings.languages.includes(window.location.hash.substr(1))
    ? window.location.hash.substr(1)
    : Settings.defaultLanguage

  const to = `/${chosenLocale}${hasIntro ? '/intro' : hasMultipleCategories ? '' : `/category/${category.key}`}`

  return (
    <StartPage>
      <PlayButton to={to}>
        <img src={startButton} alt="Start" />
      </PlayButton>
    </StartPage>
  )
}
